import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '@shared/modules/shared.module';
@Component({
	selector: 'app-action-menu',
	imports: [SharedModule],
	templateUrl: './action-menu.component.html',
	styleUrl: './action-menu.component.scss',
})
export class ActionMenuComponent {
	@Input() actions: any[] = [];
	@Input() rowData: any;
	@Input() menuPosition: { top: string; right: string } = {
		top: '0px',
		right: '0px',
	};
	@Output() actionExecuted = new EventEmitter<void>();

	executeAction(action: any): void {
		try {
			if (!action || !action.command) {
				return;
			}
			action.command();
			this.actionExecuted.emit();
		} catch (error) {
			console.error('Error en executeAction:', error);
			this.actionExecuted.emit(); // Emit anyway so the menu closes
		}
	}
}
